var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',[_vm._v("Reverb Test")]),(_vm.message)?_c('p',[_vm._v("📨 Nova mensagem: "+_vm._s(_vm.message))]):_vm._e(),_c('button',{on:{"click":_vm.sendMessage}},[_vm._v("Disparar Mensagem")])])
}
var staticRenderFns = []

export { render, staticRenderFns }